import React from 'react'

import styled from '@emotion/styled'

interface Props {
  shouldStackButtons?: boolean
}

const StyledDiv = styled.div<Props>`
  ${({ shouldStackButtons, theme }) => {
    if (shouldStackButtons) {
      return `
        display: flex;
        gap: ${theme.spacing.m};
        flex-direction: column-reverse;
      `
    } else {
      return `
        display: grid;
        gap: ${theme.spacing.m};
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      `
    }
  }}
`

interface ButtonActionsContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  shouldStackButtons?: boolean
}

export function ButtonActionsContainer({
  children,
  shouldStackButtons,
}: ButtonActionsContainerProps): React.ReactElement {
  return <StyledDiv shouldStackButtons={shouldStackButtons}>{children}</StyledDiv>
}
